// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/causali-movimento?societaId=',
    requestBody: null,
    response: '{ success: true, data: [{ id, societaId, codice, descrizione, tipo, aggiornaCmp, isDefault, attivo, note, nMovimenti }] }'
  },
  {
    method: 'POST',
    endpoint: '/api/causali-movimento',
    requestBody: '{ societaId, codice, descrizione, tipo, aggiornaCmp, isDefault, note }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'PUT',
    endpoint: '/api/causali-movimento/:id',
    requestBody: '{ codice, descrizione, tipo, aggiornaCmp, isDefault, note }',
    response: '{ success: true }'
  },
  {
    method: 'DELETE',
    endpoint: '/api/causali-movimento/:id',
    requestBody: null,
    response: '{ success: true }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
